// extracted by mini-css-extract-plugin
module.exports = {"changelogcontainer":"Changelog-styles-module--changelogcontainer--2THXc"};